<template>
    <button class="learnworlds-button learnworlds-button-solid-brand learnworlds-button-normal learnworlds-element" @click="enrollButtonClicked">
        <span>
            <div>
                <span class="v-bottom">{{ $t('bundles.buy') }}</span>
                <span class="v-bottom">
                    <span class='lw-deleted-price lw-text-color-fadeout50'>{{ bundle.currency }}{{ bundle.price }} </span>
                    <strong>{{ bundle.currency }}{{ bundle.discount_price }}</strong>
                </span>
            </div>
        </span>
    </button>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "BundlePurchaseLayout1",
        mixins: [ComponentTemplatesMixin],
        props: {
            bundle : {
                type: Object
            }
        },
        methods: {
            enrollButtonClicked () {
                this.emitAction('bundle-clicked', this.bundle)
            },
        }
    }
</script>

